import { useCallback } from 'react';
import styled from 'styled-components';

export function FilterInput({ placeholder, value, onChange }) {
  const handleChange = useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <StyledInput
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
    />
  );
}

const StyledInput = styled.input`
  padding: 0 16px;
  height: 40px;
  background: #263750;
  border: 1px solid #83bf46;
  border-radius: 8px;
  color: #f5f5f5;
  font-size: 15px;
  outline: none;
  box-sizing: border-box;
  transition: background 0.2s;
  text-overflow: ellipsis;

  &::placeholder {
    color: #b3b3b3;
  }

  &:hover,
  &:focus {
    background: #334466;
  }
`;
